import { httpManager as http } from '@/plugins/HttpManager';
import { config } from 'CONFIG';
import { ICommonRes } from '../interface/api/common';
import { getSubscriptions } from './subscriptions';
import { ISubscription } from '@reolink-cloud/interface';

export const getTrafficPackages = ( status: string ): Promise<any> => {

    return new Promise(( resolve, reject ) => {

        http.get( `/cloud/traffic/packages?status=${status}` ).then( res => {

            resolve( res.data );

        }).catch( err => {

            console.log( err );
            reject( err );

        });

    });

};

export const getTrafficUsage = ( type = 'month' ): Promise<any> => {

    return new Promise(( resolve, reject ) => {

        http.get( `/cloud/traffic/usage?type=${type}` ).then( res => {

            resolve( res.data );

        }).catch( err => {

            console.log( err );
            reject( err );

        });

    });

};

export const getTrafficDeviceStatus = (): Promise<any> => {

    return new Promise(( resolve, reject ) => {

        http.get( `/cloud/traffic/devices` ).then( res => {

            resolve( res.data );

        }).catch( err => {

            console.log( err );
            reject( err );

        });

    });

};

export const getTotalSubs = async (): Promise<{
    subs: ISubscription[];
    activeSubs: ICommonRes<ISubscription>;
    inactiveSubs: ICommonRes<ISubscription>;
}> => {

    const [activeSubs, inactiveSubs] = await Promise.all( [
        getSubscriptions( 'active' ),
        getSubscriptions( 'inactive' )
    ] );

    const subs = [...activeSubs.items, ...inactiveSubs.items];

    return { subs, activeSubs, inactiveSubs };

};

export const checkNewCustomer = ( subs: any[] ): boolean => {

    // Mon Apr 10 2023 15:00:00 GMT+0800 (中国标准时间)
    const versionTime = config.basicPlanVersionTime;

    if ( subs.length === 0 ) {

        return true;

    }

    /**
     * 在本版本之前已经订阅过任何套餐
    */
    let alreadySub = false;
    for ( const sub of subs ) {

        if ( sub.createdAt <= versionTime ) {

            alreadySub = true;
            break;

        }

    }

    return !alreadySub;

};

export const checkFreePlanTrack = ( subs: ISubscription[] ): boolean => {

    // 判断是否存在免费套餐订阅
    return subs.some( sub => sub.freePlanTrack );

};

export const ownLegacyPlan = ( subs: ICommonRes<ISubscription> ): any[] => {

    if ( subs.totalRows === 0 ) {

        return [];

    }

    /**
     * 在本版本之前已经订阅过任何套餐
    */
    const ownLegacyPlan: any[] = [];
    for ( const sub of subs.items ) {

        if ( sub.legacyTag ) {

            ownLegacyPlan.push( sub.storageRegion );

        }

    }

    return ownLegacyPlan;

};
